<template>
  <div class="fixed inset-0 flex items-center justify-center z-[99999]">
    <div class="fixed inset-0 bg-gray-900 opacity-75"></div>
    <div>

      <div class="dot-loading">
        <div class="logo" :style="{ backgroundImage: `url(${imageURL})` }"></div>
        <div class="dots" :class="{ animate: animateClass }">
          <div class="dot"><span uk-icon="icon: facebook" class="uk-icon"><svg width="20" height="20" viewBox="0 0 20 20">
                <path
                  d="M11,10h2.6l0.4-3H11V5.3c0-0.9,0.2-1.5,1.5-1.5H14V1.1c-0.3,0-1-0.1-2.1-0.1C9.6,1,8,2.4,8,5v2H5.5v3H8v8h3V10z">
                </path>
              </svg></span></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'loader-form',
  props: {
    message: String,
  },
  data() {
    return {
      animateClass: true,
      intervalId: null,
      imageURL: '/assets/in-flight.svg'
    }
  },
  methods: {
    formloader() {
      this.intervalId = setInterval(() => {
        this.animateClass = false;
        setTimeout(() => {
          this.animateClass = true;
        }, 200);
      }, 3750);
    }
  },
  mounted() {
    this.formloader();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  }
};
</script>

<style scoped>
.logo{
height: 80px;
width: 200px;
background-repeat: no-repeat;
}
.dot-loading {
  width: 100%;
  height: 100%;
}

.dot-loading * {
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0) rotate(0deg);
  transform: translate3d(-50%, -50%, 0) rotate(0deg);
}

.loader_modal .dot-loading .logo {
  background-repeat: no-repeat;
  background-position: center;
  width: 380px;
  height: 100%;
}

.dot-loading .dots.animate .dot {
  -webkit-animation: dot-loading-block 2.5s ease-in-out 1;
  animation: dot-loading-block 2.5s ease-in-out 1;
}

.dot-loading .dots.animate .dot:after {
  -webkit-animation: dot-loading-dot 2.5s ease-in-out 1;
  animation: dot-loading-dot 2.5s ease-in-out 1;
}

.dot-loading .dots .dot {
  width: 300px;
  height: 300px;
}

.dot-loading .dots .dot:after {
  content: "";
  display: inline-block;
  width: 60px;
  height: 60px;
  background-color: #ffffff;
  border-radius: 50%;
  position: absolute;
  -webkit-transform: scale(0);
  transform: scale(0);
}

.dot-loading .dots .dot:nth-child(1) {
  top: 148px;
  left: -145px;
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}

.dot-loading .dots .dot:nth-child(1):after {
  -webkit-transform-origin: top right;
  transform-origin: top right;
  top: 0;
  right: 0;
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}

.dot-loading .dots .dot:nth-child(2) {
  top: -160px;
  left: -194px;
  -webkit-animation-delay: 0.25s;
  animation-delay: 0.25s;
}

.dot-loading .dots .dot:nth-child(2):after {
  -webkit-transform-origin: bottom right;
  transform-origin: bottom right;
  bottom: 0;
  right: 0;
  -webkit-animation-delay: 0.25s;
  animation-delay: 0.25s;
}

.dot-loading .dots .dot:nth-child(3) {
  top: -160px;
  left: -102px;
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}

.dot-loading .dots .dot:nth-child(3):after {
  -webkit-transform-origin: bottom right;
  transform-origin: bottom right;
  bottom: 0;
  right: 0;
  -webkit-animation-delay: 0.5s;
  animation-delay: 0.5s;
}

.dot-loading .dots .dot:nth-child(4) {
  top: 117px;
  left: 200px;
  -webkit-animation-delay: 0.75s;
  animation-delay: 0.75s;
}

.dot-loading .dots .dot:nth-child(4):after {
  -webkit-transform-origin: top left;
  transform-origin: top left;
  top: 0;
  left: 0;
  -webkit-animation-delay: 0.75s;
  animation-delay: 0.75s;
}

.dot-loading .dots .dot:nth-child(5) {
  top: -160px;
  left: 213px;
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}

.dot-loading .dots .dot:nth-child(5):after {
  -webkit-transform-origin: bottom left;
  transform-origin: bottom left;
  bottom: 0;
  left: 0;
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}

@-webkit-keyframes dot-loading-block {
  100% {
    -webkit-transform: translate3d(-50%, -50%, 0) rotate(360deg);
    transform: translate3d(-50%, -50%, 0) rotate(360deg);
  }
}

@keyframes dot-loading-block {
  100% {
    -webkit-transform: translate3d(-50%, -50%, 0) rotate(360deg);
    transform: translate3d(-50%, -50%, 0) rotate(360deg);
  }
}

@-webkit-keyframes dot-loading-dot {
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

@keyframes dot-loading-dot {
  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
